import { useState, useEffect, useRef } from 'react';
import { ArrowForward } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { Button, Box, MenuItem, Menu, CircularProgress } from '@mui/material';
import Iconify from '../../../reusable-components/iconify';

QuickSearchDropdown.propTypes = {
  searchValue: PropTypes.string, 
  quickAdvancedFilter: PropTypes.bool,
  setQuickAdvancedFilter: PropTypes.func,
  handleSearchCall: PropTypes.func,
  goToAdvancedSearch: PropTypes.func,
  loading: PropTypes.bool,
  searchResultItems: PropTypes.array,
  setSearchResults: PropTypes.func,
  searchResults: PropTypes.object,
  searchInputRef: PropTypes.object
}

export default function QuickSearchDropdown({ searchValue, quickAdvancedFilter, setQuickAdvancedFilter, handleSearchCall, goToAdvancedSearch, loading, searchResultItems, setSearchResults, searchResults, searchInputRef }) {
  const iconRef = useRef(null);
  const [menuAnchor, setMenuAnchor] = useState(null);

  useEffect(() => {
    if (quickAdvancedFilter && iconRef) {
      setQuickAdvancedFilter(false);
      setMenuAnchor(searchInputRef?.current);
      handleSearchCall();
    }
  }, [quickAdvancedFilter, iconRef]);

  const handleSearch = (e) => {
    if (!searchValue) return;
    setMenuAnchor(searchInputRef?.current);
    handleSearchCall();
  };

  return <>
    {searchValue &&
    <Button
      ref={iconRef}
      color="secondary"
      sx={{ ml: 1, py: 0, px: 1, my: 1}}
      onClick={handleSearch}
    >
      <Iconify sx={{mr: 0.5}} icon={'fa6-brands:searchengin'} width={15} height={15}/> Advanced Search
    </Button>}
    <Menu
      sx={{mt: 0.5}}
      anchorEl={menuAnchor}
      open={!!menuAnchor}
      onClose={() => { setMenuAnchor(null); setSearchResults(null); }}
      PaperProps={{
        sx: {
          width: searchInputRef?.current?.offsetWidth || 300,
          boxShadow: '0px 8px 32px 0px rgba(40,40,60,0.35), 0px 1.5px 6px 0px rgba(40,40,60,0.18)',
        }
      }}
    >
      <Box sx={{ width: '100%', maxHeight: "55vh", overflow: "auto", display: "flex", flexDirection: "column" }}>
        {!loading ? (
          <>
            <Box sx={{ flex: 1, overflow: "auto" }}>
              {searchResultItems}
            </Box>
            <Box sx={{ position: "sticky", bottom: 0, backgroundColor: "white", zIndex: 1 }}>
              <MenuItem onClick={goToAdvancedSearch}>
                {searchResults?.totalCount > 5 ? `See More` : `Advanced Search`} 
                <ArrowForward sx={{ fontSize: 20, ml: .5 }} />
              </MenuItem>
            </Box>
          </>
        ) : (
          <MenuItem disabled sx={{ justifyContent: "center", display: "flex" }}>
            <Box sx={{ height: 35 }}>
              <CircularProgress size={30} sx={{ justifySelf: "center" }} />
            </Box>
          </MenuItem>
        )}
      </Box>
    </Menu>
  </>;
}
